import { EMPTY_ADDRESS_PAIR_FORM } from '../address/create-pair-form.js';
import { createCustomerBillingAndShippingAddressesInputSchema } from './create-pair-input.js';
import { toCreateCustomerAddressPairInput } from './to-create-customer-address-pair-input.js';
export const EMPTY_CUSTOMER_ADDRESS_PAIR_FORM = {
    ...EMPTY_ADDRESS_PAIR_FORM,
};
export function toCreateCustomerBillingAndShippingAddressesInput(values, customerName) {
    return createCustomerBillingAndShippingAddressesInputSchema.parse({
        name: customerName,
        ...toCreateCustomerAddressPairInput(values),
    });
}
//# sourceMappingURL=create-pair-mapper.js.map